import { Helmet } from 'react-helmet-async';

// sections
import { CustomerReceivable } from 'src/sections/customerReceivable/view';

// ----------------------------------------------------------------------

export default function CustomerReceivableListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Customer Receivable</title>
      </Helmet>

      <CustomerReceivable />
    </>
  );
}
